const shortDateFormatter = new Intl.DateTimeFormat("en", {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
});

const longDateFormatter = new Intl.DateTimeFormat("en", {
	day: "2-digit",
	month: "long",
	year: "numeric",
});

const midDateFormatter = new Intl.DateTimeFormat("en", {
	day: "2-digit",
	month: "short",
	year: "numeric",
});

export const shortDate = value => shortDateFormatter.format(new Date(value));
export const longDate = value => longDateFormatter.format(new Date(value));
export const midDate = value => midDateFormatter.format(new Date(value));
